import React from 'react'
import { connect } from 'react-redux'
// import { Layout } from 'antd'
import { Col, Row } from 'reactstrap';

import classNames from 'classnames'
import Main from '../../Main';

const mapStateToProps = ({ settings }) => ({
  logo: settings.logo,
  isGrayTopbar: settings.isGrayTopbar,
  isCardShadow: settings.isCardShadow,
  isSquaredBorders: settings.isSquaredBorders,
  isBorderless: settings.isBorderless,
  authPagesColor: settings.authPagesColor,
})

const AuthLayout = props => {
  return (
      <Main {...props}>
      </Main>
  )
}

export default (connect(mapStateToProps)(AuthLayout))
